import { AC3BaseError } from './AC3BaseError';
import { TeamCTI } from '../TeamCTI';
export class RingtoneAudioOutputError extends AC3BaseError {
    constructor(message, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    cause, errorCodeContextInputs, displayContext) {
        const cti = TeamCTI.Sapphire.internal;
        if (errorCodeContextInputs && !errorCodeContextInputs.cti) {
            errorCodeContextInputs = Object.assign(Object.assign({}, errorCodeContextInputs), { cti });
        }
        super(message, cause, errorCodeContextInputs, displayContext);
        this.name = 'RingtoneAudioOutputError';
    }
}
//# sourceMappingURL=RingtoneAudioOutputError.js.map